import { useContentfulImages } from '@snapchat/mw-contentful-client';
import { ImageButton as ImageButtonSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useContext } from 'react';

import { ElementLocation } from '../../context/ElementLocationContext/ElementLocationContext';
import { shouldFlushLogs } from '../../helpers/getLocalPath';
import { logger, logUserEvent } from '../../helpers/logging';
import type { ContentfulIdVariable } from '../../hooks/useContentfulQuery';
import { useContentfulQuery } from '../../hooks/useContentfulQuery';
import { UserAction } from '../../types/events';
import type { ContentfulSysId } from '../../utils/contentful/contentfulQuery';
import { parseMedia } from '../../utils/media';
import type { ImageButtonData } from './imageButtonQuery';
import { query } from './imageButtonQuery';

export const LazyImageButton: FC<ContentfulSysId> = props => {
  const { data } = useContentfulQuery<ImageButtonData, ContentfulIdVariable>(query, {
    variables: { id: props.sys.id },
  });
  const { getImageSources } = useContentfulImages();
  const elementLocation = useContext(ElementLocation).elementLocation;

  if (!data?.imageButton) return null;

  const { url, image, ...rest } = data.imageButton;

  const { imageSource, imageAltText } = parseMedia(image);
  const imgSrcs = getImageSources(imageSource);

  const onClickHandler = (): void => {
    logUserEvent({
      eventAction: UserAction.Click,
      eventCategory: 'ImageButton',
      context: {
        targetUrl: url,
        elementLocation,
        // image button, no element text
      },
    });

    if (shouldFlushLogs(url)) {
      void logger.flush();
    }
  };

  return (
    <ImageButtonSDS
      {...rest}
      url={url}
      onClick={onClickHandler}
      imgSrcs={imgSrcs}
      altText={imageAltText}
    />
  );
};
